<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center">
      <div class="w-100-porcento">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filiais"
          label="Filial"
          outlined
          hide-details
          multiple
        />
      </div>
    </div>

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      outlined
      multiple
      hide-details
      class="mt-4"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import $axios from "@/api/api";

import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from '@/components/utils/crud/SysCompradorAutocomplete.vue';

export default {
  name: "ProdutosFatorAtuacao",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysCompradorAutocomplete
  },
  data: () => ({
    filtros: {
      filiais: [],
      segmentos: [],
      fornecedores: [],
      compradores: [],
      venda_futura_maior_que_saldo_estoque: 'N'
    }
  }),
  mounted() {
    this.gerarRelatorio();
  },
  watch: {
    DIALOG_ATIVO(valor) {
      if (valor) this.gerarRelatorio();
    }
  },
  methods: {
    gerarRelatorio() {
      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
